import { classnames } from 'tailwindcss-classnames';

/**
 * Base Classes (could be moved to a global location in the future)
 */
const baseHeadingClasses = classnames('mb-2', 'md:mb-4', 'max-w-prose');
const baseParagraphClasses = classnames('pb-2');
const baseSectionClasses = classnames('mb-6');
const baseDisclaimerClasses = classnames('text-sm', 'text-gray-darkGray', 'mb-2', 'md:mb-4');
const baseLinkClasses = classnames(
  'text-blue',
  'underline',
  'font-bold',
  'hover:text-theme-btn-link-text-hover'
);

export const TcDirectoryListingClasses = {
  Disclaimer: baseDisclaimerClasses,
  Paragraph: baseParagraphClasses,
  Heading: {
    Large: classnames(baseHeadingClasses, 'heading-lg'),
    Medium: classnames(baseHeadingClasses, 'heading-md'),
  },
  Link: baseLinkClasses,
  SectionWrapper: baseSectionClasses,
};
